// Realtime WebSocket — type definitions for the wire format
// documented in `docs/architecture/realtime-protocol.md` + the
// per-event payload shapes from `docs/architecture/events.md §4`.
//
// Single source of truth for client-side type narrowing on the
// `socket.on('domain', body => ...)` handler. Prevents per-call-site
// `as { from, to }` casts and makes a `switch (body.eventType)`
// exhaustive at compile time.
//
// Keep in sync with:
//   - apps/api/src/realtime/realtime.gateway.ts (broadcast body)
//   - apps/api/src/outbox/outbox-dispatcher.service.ts (emit shape)
//   - apps/api/src/**/*.service.ts (every outbox.enqueue() call site)
//   - docs/architecture/events.md §4 (canonical payload reference)
//   - tools/check-event-catalogue.ts (drift gate)
// --- Type-guard helper ---------------------------------------------
/**
 * Narrowing type guard. Lets a switch on `body.eventType` infer
 * `body.payload` automatically:
 *
 * ```ts
 * if (isDomainEvent(body, 'RobotStatusChanged')) {
 *   const { from, to } = body.payload;  // narrowed
 * }
 * ```
 *
 * The runtime check is just a string compare, but the type
 * predicate flips on the discriminated `eventType` literal.
 */
export function isDomainEvent(body, eventType) {
    return body.eventType === eventType;
}
//# sourceMappingURL=realtime.js.map